import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ClassNames from 'classnames';

const useStyles = makeStyles(theme => ({
  item: {
    paddingLeft: 17,
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '1',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.body2,
      lineHeight: 1.7,
    },
    '& > span': {
      ...theme.typography.overline,
      lineHeight: '22px',
    },
  },
  activeItem: {
    color: theme.palette.primary.main,
  },
  itemWrapper: {
    height: 34,
  },
  ul: {
    listStyleType: 'none',
    columns: 2,
    margin: 0,
    padding: 0,
    marginLeft: 20,
  },
  simpleList: {
    columns: 1,
    width: '100%',
    paddingTop: 34,
    margin: 0,
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
    '& span': {
      ...theme.typography.body2,
      lineHeight: '33px',
    },
  },
  li: {
    paddingLeft: 18,
    paddingTop: 0,
    paddingBottom: 0,
    '&:before': {
      content: '*',
    },
  },
  listIcon: {
    minWidth: 0,
  },
}));

function TypesList({ types, selectType, selectedValue }) {
  const classes = useStyles();
  return (
    <Grid item xs={12}>
      <SimpleBar style={{ maxHeight: 300 }}>
        <Grid container>
          <List
            component="nav"
            aria-label="topics list"
            className={classes.simpleList}
          >
            {types.map(({ label, value, icons }) => {
              const event = {
                target: {
                  value: label,
                },
              };
              return (
                <ListItem
                  button
                  className={classes.li}
                  onClick={() => selectType(null, event, 'selectedMediaType')}
                  key={value}
                >
                  {icons && (
                    <ListItemIcon className={classes.listIcon}>
                      <img
                        src={selectedValue === value ? icons[0] : icons[1]}
                        alt="Type Icon"
                        className={classes.icon}
                      />
                    </ListItemIcon>
                  )}

                  <ListItemText
                    className={ClassNames(
                      classes.item,
                      selectedValue === value ? classes.activeItem : undefined,
                    )}
                  >
                    {label}
                  </ListItemText>
                </ListItem>
              );
            })}
          </List>
        </Grid>
      </SimpleBar>
    </Grid>
  );
}

TypesList.propTypes = {
  types: PropTypes.array,
  selectType: PropTypes.func,
  selectedValue: PropTypes.string,
};

export default TypesList;
